module.exports = __webpack_public_path__ + "static/media/CombinedMessagingChannelIcon.7f6e1c4f.svg";